async function _getCurrentProduct() {
  let url = "https://" + window.location.host + window.location.pathname + ".json";
  return new Promise(async (resolve, reject) => {
    let response = await fetch(url);
    let { product } = await response.json();
    resolve(product);
  });
}

async function _getCurrentVariant() {
  const product = await _getCurrentProduct();
  const variant = await _getVariantID(product);
  return variant;
}

function _getVariantID(product) {
  let currentVariantID = document.querySelector('variant-selects select').value
  const variant = product.variants.filter((e) => e.option1 === currentVariantID)[0];
  return variant;
  console.log('variant', variant)
}

function isInUs() {
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return [
    'America/Boise',
    'America/Chicago',
    'America/Denver',
    'America/Detroit',
    'America/Fort_Wayne',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indianapolis',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Knox_IN',
    'America/Los_Angeles',
    'America/Louisville',
    'America/Menominee',
    'America/New_York',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Phoenix',
  ]. includes(timeZone);
}

async function currentVariant() {
  var variant = await _getCurrentVariant();
  let product = await _getCurrentProduct();

  const container = document.getElementById('stock_status');
  const qty = await variant.inventory_quantity;
  const oversell = await variant.inventory_policy;
  const priceNoSale = await variant.price;
  const vendor = await product.vendor;
  let price;

  let currentVariantID = document.querySelector('variant-selects select').value
  let qtyToAdd = document.querySelector("input[name='quantity']").value;  

  // if (document.querySelector("#turning-sale-on")){
  // let colorVariants = Array.from(document.querySelectorAll(".figure"))
  // let filteredColorVariants = colorVariants.filter(c => c.dataset.variantColor === variant.title)[0];
  // let currentColorPrice = filteredColorVariants.dataset.salePrice;
  // price = currentColorPrice;
  // } else {
  // price = priceNoSale;
  // }
  
  let in_stock = false;
  let in_hours = false;
  let is_domestic = false;
  let is_weekday = false;
  let is_weekday_tmr;
  let is_friday = false;
  let is_shippingtmw = false;
  let is_over150usd = false;
  let msg_one;
  let msg_two;

  let virtual = false;
  if (product.tags.includes(`Condition:Virtual`)){
    virtual = true;
  }


  if (qty <= 0 && oversell != 'continue') {
    msg_one = ' <span class="outofstock">Out of Stock</span>';
    
  } else if (qty > 0 && qty < 5 && qty < qtyToAdd && oversell != "deny") {
    msg_one = '<span style="color: #417a11">In Stock</span>';
    msg_two = 'Ships in 1-2 Business Days!'

      if (vendor == "TressAllure" 
          || vendor == "BelleTress" 
          || vendor == "Forever Young" 
          || vendor == "Ellen Wille"
          || vendor == "Vivica Fox") {
      msg_two = "Ships in 1-2 Business Days"
    }
    
  } else if (qty > 0 && qty < 5) {
    msg_one = ' <span style="color: #417a11">Only ' + qty + ' Left!</span>';
    in_stock = true;
    
  } else {
    msg_one = ' <span style="color: #417a11">In Stock</span>';
    in_stock = true;
  }

  if (price > 149) {
    is_over150usd = true;
  }
      
  let d = new Date();
  if(d.getDay() != 6 && d.getDay() != 0) {
    is_weekday = true;
  }

  if(d.getDay() != 5 && d.getDay() != 1) {
    is_weekday_tmr = true;
  }

  let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  // winter time
  // let nd = new Date(utc - 21600000);
  //summer time
  let nd = new Date(utc - 18000000);
  let time = nd.getHours();

  if (time > 00 && time < 16) {
    in_hours = true;
  }
  
  if (!isInUs()) {
    is_domestic = false;
  } else {
    is_domestic = true;
  }

  if (qty <= 0 && oversell == 'continue' && is_over150usd && is_domestic) {
      msg_two = 'Ships in 1-2 Days for FREE!';
  
      if (vendor == "TressAllure" 
          || vendor == "BelleTress" 
          || vendor == "Forever Young" 
          || vendor == "Ellen Wille"
          || vendor == "Vivica Fox") {
        msg_two = "Ships FREE in 1-2 business days";
      }
  } else if (qty <= 0 && oversell == 'continue') {
      msg_two = 'Ships in 1-2 Business Days!';
  
      if ((vendor == "TressAllure" 
          || vendor == "BelleTress" 
          || vendor == "Forever Young" 
          || vendor == "Ellen Wille"
          || vendor == "Vivica Fox") && !is_weekday_tmr) {
        msg_two = 'Ships in 1-2 business days';
      }
    
  } else if (in_stock && is_weekday && in_hours && is_over150usd && is_domestic) {
    msg_two = 'Ships Today for FREE!';
    
  } else if(in_stock && is_weekday && in_hours) {
    msg_two = 'Ships Today!';
    
  } else if(in_stock && !is_weekday && !is_weekday_tmr && !is_over150usd) {
    msg_two = 'Ships Monday';

  } else if(in_stock && in_hours && !is_weekday && is_weekday_tmr && is_over150usd) {
    msg_two = 'FREE SHIPPING!';
    
  } else if(in_stock && is_over150usd && !in_hours && is_domestic) {
    msg_two = 'FREE SHIPPING!';
    
  } else if (in_stock && !in_hours && is_over150usd && !is_domestic) {
    msg_two = 'Ships Tomorrow';
    
  } else if(in_stock && !is_weekday_tmr && !is_over150usd) {
    msg_two = 'Ships Monday';
    
  } else if (in_stock && !in_hours && !is_over150usd) {
    msg_two = 'Ships Tomorrow';
    
  }
  
  if (oversell == "deny" && qtyToAdd > qty) {
    msg_two = "Can't Ship More Than " + qty;
  }

   if (product.tags.includes(`Liquid:UNAVAILABLE-${variant.title}`)){
      msg_one = ' <span class="outofstock">BACK SOON!</span>';
      msg_two = "";
  }

    if (product.tags.includes(`Condition:Virtual`)){
      msg_two = "Ships in 1-3 business days";
  }
    
  if (msg_two) {
    msg_one = msg_one +' <div style="padding-top: 20px"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg_two +'</div>';
  }
  
  let is_activevariant = document.querySelector('variant-selects select').value;

  // console.log("qty",qty);
  // console.log("oversell",oversell);
  // console.log('in_stock',in_stock);
  // console.log('in_hours',in_hours);
  // console.log('is_domestic',is_domestic);
  // console.log('is_weekday',is_weekday);
  // console.log('is_over150usd',is_over150usd);
  // console.log('is_activevariant',is_activevariant);
  // console.log('sku',variant.sku);
  // console.log("currentVariantID",currentVariantID);
  // console.log("date",d);
  // console.log("is weekday tomorrow", is_weekday_tmr);
      
  if (is_activevariant != ''){
    container.innerHTML = msg_one;
  }
}

function addCustomEventListener(selector, event, handler) {
  let rootElement = document.querySelector('body');
  rootElement.addEventListener(event, function (evt) {
    let targetElement = evt.target;
    while (targetElement != null) {
      if (targetElement.matches(selector)) {
        handler(evt);
        return;
      }
      targetElement = targetElement.parentElement;
    }
  }, true);
}

function taskClickHandler(e) {
  currentVariant();
}
    
addCustomEventListener('variant-selects', 'change', taskClickHandler);
addCustomEventListener('.figure', 'click', taskClickHandler);
addCustomEventListener('.quantity__input', 'change', taskClickHandler);


if (document.getElementById('current_selected_variant')) {
  currentVariant();
}

if (document.querySelector('variant-selects select').value != "choose-a-color") {
  currentVariant();
}
